/**
 * Messaging Components Index
 * 
 * Modular messaging architecture with:
 * - Components: ThreadList, ThreadView, MessageBubble, MessageInput
 * - Hooks: useMessagesWebSocket, useThreads
 * - Types: All shared TypeScript interfaces
 * - Offline: offlineMessages service for IndexedDB queue
 */

// Main modal
export { default as MessagesModal } from './MessagesModalNew';

// Components
export { default as ThreadList } from './ThreadList';
export { default as ThreadView } from './ThreadView';
export { default as MessageBubble } from './MessageBubble';
export { default as MessageInput } from './MessageInput';

// Hooks
export { useMessagesWebSocket } from './hooks/useMessagesWebSocket';
export { useThreads } from './hooks/useThreads';

// Types
export * from './types';
